import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { JOB_STATUS_LABELS } from '../utils/statusConstants';

const RequestDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    apiFetch(`/requests/${id}`).then((r) => setData(r.data));
  }, [id]);

  if (!data) return <p className="text-slate-500">Loading…</p>;

  const { job, photos } = data;
  const before = photos.filter((p) => p.phase === 'before');
  const after = photos.filter((p) => p.phase === 'after');

  return (
    <div>
      <Link to="/requests" className="text-sm text-teal-700 mb-4 inline-block">
        ← My requests
      </Link>
      <h1 className="text-2xl font-semibold">{job.job_number}</h1>
      <p className="text-slate-600 text-sm mt-1 mb-6">
        {JOB_STATUS_LABELS[job.status] || job.status} · {job.location_label || job.city}
      </p>

      <div className="bg-white rounded-xl shadow border border-slate-100 p-6 space-y-3 text-sm">
        <p>
          <span className="text-slate-500">Address:</span>{' '}
          {job.address_line1}, {job.city}, {job.state} {job.postal_code}
        </p>
        <p>
          <span className="text-slate-500">Service:</span> {job.service_type}
        </p>
        {job.scheduled_start && (
          <p>
            <span className="text-slate-500">Scheduled:</span>{' '}
            {new Date(job.scheduled_start).toLocaleString()}
          </p>
        )}
        {job.notes && (
          <p>
            <span className="text-slate-500">Notes:</span> {job.notes}
          </p>
        )}
      </div>

      {(before.length > 0 || after.length > 0) && (
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          <div className="bg-white rounded-xl shadow p-4">
            <h2 className="font-medium mb-2">Before ({before.length})</h2>
            <p className="text-xs text-slate-500">Photos appear when your cleaner uploads them.</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4">
            <h2 className="font-medium mb-2">After ({after.length})</h2>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestDetail;
